import React from 'react'

interface IPortalContainer {
  children: React.ReactNode
}

const PortalContainer: React.FC<IPortalContainer> = React.memo(({ children }) => {
  return (
    <div className='bg-grey9 rp-main-container mbsc-grid'>
      <div className='items-center justify-center mbsc-row'>
        <div className='mbsc-col-12 rp-component-wrapper'>{children}</div>
      </div>
    </div>
  )
})

export default PortalContainer



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/PortalContainer.tsx